<template>
  <div
    class="container lms-wrapper no-right-sidebar pd-x-0 pd-lg-x-10 pd-xl-x-0"
  >
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav @route-changed="toggleNavbar(false)"></student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <ul class="nav nav-line nav-line-profile mg-b-10">
          <li class="nav-item">
            <router-link
              to="/lms/paymentList/0"
              aria-current="page"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.status == 0 ? 'active' : ''
                }`
              "
            >
              Төлөгдөөгүй
              <!-- <span class="badge">{{counts.active}}</span> -->
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="hasEbarimt"
              to="/lms/paymentList/1"
              aria-current="page"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.status == 1 ? 'active' : ''
                }`
              "
              >И-Баримт</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/lms/paymentList/2"
              aria-current="page"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.status == 2 ? 'active' : ''
                }`
              "
            >
              Бүгд
              <!-- <span class="badge">{{counts.joined}}</span> -->
            </router-link>
          </li>
        </ul>
        <div class="row">
          <div class="col-lg-12 col-xl-12">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.content}px; position: relative; `"
            >
              <div class="row no-gutters">
                <div
                  v-for="(invoice, i) in list.filter(x =>
                    $route.params.status == 0
                      ? x.isTender != true
                      : $route.params.status == 1
                      ? x.isTender == true
                      : true
                  )"
                  :key="'event' + i"
                  class="col-md-12 mg-t-20 mg-md-t-0"
                >
                  <template v-if="!invoice.isTender">
                    <router-link
                      :to="`/lms/paymentDetail/${invoice.id}`"
                      class="link-01"
                    >
                      <invoice-item :invoice="invoice" @on-delete="onDelete"></invoice-item>
                    </router-link>
                  </template>
                  <template v-else>
                    <div @click="showInvoice(invoice)">
                      <invoice-item
                        :hasEbarimt="hasEbarimt"
                        :invoice="invoice"
                      ></invoice-item>
                    </div>
                  </template>
                </div>
              </div>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="ebarimtObj.modal"
      hide-footer
      title="И-Баримт"
      centered
      body-class="pd-0"
      size="md"
      scrollable
    >
      <div class="modal-body" ref="mdlEbarimt" style="font-size: 0.85em">
        <!-- {{modalEbarimt.id}} -->
        <template v-if="ebarimtObj.mode == 1">
          <Form label-width="160">
            <FormItem label="И-баримт авах хэлбэр">
              <Select v-model="ebarimtObj.type" plaeHolder="Сонгоно уу">
                <Option value="1" label="Байгууллага">Байгууллага</Option>
                <Option value="0" label="Хувь хүн">Хувь хүн</Option>
              </Select>
            </FormItem>
            <FormItem label="Байгууллагын регистр" v-if="ebarimtObj.type == 1">
              <Input v-model="ebarimtObj.regNo" placeholder="Бичнэ үү.." />
            </FormItem>
          </Form>
          <div class="pd-sm">
            <button
              @click="generateEbarimt()"
              class="btn btn-block btn-primary"
            >
              Баримт авах
            </button>
          </div>
        </template>
        <template v-else-if="ebarimtObj.mode == 2">
          <div class="pd-md">
            <div class="row d-flex mb-10">
              <div class="col col-12 text-center m-b-md">
                <h5 >
                  {{companyName}}
                  <!-- Монголын мэргэшсэн нягтлан бодогчдын институт -->
                </h5>
              </div>
              <div class="col col-4">Огноо</div>
              <div class="col col-8 text-right">
                {{ ebarimtObj.ebarimt.date | moment("YYYY.MM.DD HH:mm") }}
              </div>
              <div class="col col-4">ТТД</div>
              <div class="col col-8 text-right">
                {{ ebarimtObj.ebarimt.billId }}
              </div>
            </div>
            <table
              class="tbl-stock"
              style="width: 100%"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <th style="width: 30px">Д/д</th>
                <th>Бичилт</th>
                <th style="width: 80px;">Нэгж үнэ</th>
                <th style="width: 30px">Хэмжээ</th>
                <th style="width: 80px">Нийт үнэ</th>
              </thead>
              <tbody>
                <tr
                  v-for="(s, i) in ebarimtObj.ebarimt.stocks"
                  :key="i"
                  style="border-top: 1px solid #000"
                >
                  <td style="text-align: center">{{ i + 1 }}</td>
                  <td style="text-align: left">{{ s.name }}</td>
                  <td>{{ s.unitPrice }}</td>
                  <td>{{ s.qty }}</td>
                  <td>{{ s.totalAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row d-flex">
            <div class="col col-12 text-center">
              <img :src="`data:image/png;base64, ${ebarimtObj.base64}`" />
              <!-- <qrcode-vue id="qr_canvas" :value="ebarimtObj.ebarimt.qrData" :size="qrOption.size" level="L" ></qrcode-vue> -->
              <!-- {{ebarimtObj.ebarimt}} -->
            </div>
            <div class="col col-5 text-right p-r-xs">Дүн:</div>
            <div class="col col-7" style="font-weight: 700">
              {{ ebarimtObj.ebarimt.amount }}
            </div>
            <div class="col col-5 text-right p-r-xs">Сугалаа:</div>
            <div class="col col-7" style="font-weight: 700">
              {{ ebarimtObj.ebarimt.lottery }}
            </div>

            <div class="text-right notprint wd-100p">
              <button
                @click="downloadEbarimt()"
                class="btn btn-sm btn-outline-primary notprint mg-r-20"
              >
                ТАТАХ
              </button>
            </div>
          </div>
        </template>
        <div v-else-if="ebarimtObj.mode == 3" class="p-md">
          <div
            class="ivu-alert ivu-alert-info ivu-alert-with-icon ivu-alert-with-desc"
          >
            <span class="ivu-alert-icon">
              <i class="ivu-icon ivu-icon-ios-information-circle-outline"></i>
            </span>
            <span class="ivu-alert-message">Санамж</span>
            <span class="ivu-alert-desc"
              >Та байгууллага дээр Е баримт авах бол info@monicpa.mn хаягаар
              төлбөр төлсөн баримт байгууллагын регистрийн дугаараа холбоо барих
              дугаартай явуулна уу! Лавлах 70007888</span
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
@media print {
  .notprint {
    display: none !important;
  }
}
.tbl-stock thead tr th {
  text-align: left;
}
.tbl-stock tbody tr td {
  border-top: 2px solid #000;
  text-align: right;
  padding: 5px 0;
  line-height: 1.2;
}
.gn-fields .ivu-card-body .ivu-form .ivu-form-item {
  margin-bottom: 10px !important;
}
/* .ivu-form-item{
  margin-bottom: 10px !important;
} */
</style>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import { Form, FormItem, Input, Select, Option, MessageBox } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default {
  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
    MessageBox,
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    invoiceItem: () => ({
      component: import("@/views/modules/lms/payment/list/paymentItemNew.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },
      counts: {
        joined: 0,
        active: 0
      },
      list: [],
      rawList: [],
      // modalEbarimt: {
      //   id: 0,
      //   show: false,
      //   data: {}
      // },
      types: [],
      flag1: -1,
      hasEbarimt: false,
      ebarimtObj: {
        modal: false,
        key: 0,
        id: 0,
        type: null,
        regNo: "",
        mode: 0,
        ebarimt: {},
        base64: null
      },
      qrOption: {
        value: "",
        size: 150
      },
      companyName:""
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    //alert(this.$store.state.user.userInfo.locType4Code)
    if (this.$store.state.user.userInfo.locType4Code == "member") {
      this.flag1 = 2;
    } else if (
      this.$store.state.user.userInfo.locType4Code == "register" ||
      this.$store.state.user.userInfo.locType4Code == "learning"
    ) {
      this.flag1 = 3;
    }

    
    let _companyName = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyName"
    );
    if (
      _companyName.length > 0 
    ) {
      this.companyName = _companyName[0].value;
    }
    
    let _ebarimt = this.$store.state.app.groupSettings.filter(
      x => x.key == "paymentEbarimt"
    );
    if (
      _ebarimt.length > 0 &&
      _ebarimt[0].value != undefined &&
      _ebarimt[0].value == "1"
    ) {
      this.hasEbarimt = true;
    }

    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    onDelete(e){
      MessageBox.confirm('Устгахдаа итгэлтэй байна уу?', 'Warning', {
        confirmButtonText: 'ТИЙМ',
        cancelButtonText: 'Үгүй',
        type: 'warning'
      }).then(() => {
        this.toggleBodyClass("addClass", "lms-sidebar-show");
        request({
          api: { method: "POST", url: "Task/Delete" },
          params: { id: e.id },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
          if(res!=false){
            this.init();
          }
        });
      });
    },
    init() {
      request({
        api: { method: "get", url: "Payment/GetMyInvoices" },
        store: this.$store
      }).then(res => {
        this.list = _.orderBy(res.data.tasks, ["id"], ["desc"]);
        if(this.$route.params.cur!=undefined){
          if(parseInt(this.$route.params.cur,10)>0){
            let _cur= this.list.filter(x=>x.id==parseInt(this.$route.params.cur,10));
            if(_cur.length>0){
              this.showInvoice(_cur[0]);
            }            
          }
        }
        // this.counts.active = res.data.tasks.filter(
        //   x => x.request.flag == this.flag1 && x.date.future
        // ).length;
        // this.counts.joined = res.data.tasks.filter(
        //   x => x.isJoined
        // ).length;
      });
    },
    showInvoice(e) {
      if (e.isTender) {
        //let hasEbarimt= getConfigValueByKey( this.$store.state.app.groupSettings, "paymentEbarimt");
        if (this.hasEbarimt != undefined) {
          if (this.hasEbarimt == 1) {
            this.showEbarimtQR(e.id, 0);
          } else {
            //this.$Notice.success({ desc: "Төлбөр төлөгдсөн байна." });
          }
        } else {
          //this.$Notice.success({ desc: "Төлбөр төлөгдсөн байна." });
        }
      }
      //else{
      //this.showPayment(e.id);
      //}
    },
    showEbarimtQR(id, mode) {
      //checkEBarimt({id: id})
      //EBarimt/CheckEBarimt
      request({
        api: { method: "POST", url: "EBarimt/CheckEBarimt" },
        store: this.$store,
        data: { id: id }
      }).then(res => {
        if (res != false) {
          if (res.data.result == 0) {
            this.ebarimtObj.mode = 1;
            this.ebarimtObj.id = id;
            this.ebarimtObj.modal = true;
            this.ebarimtObj.key++;
          } else if (res.data.result == 1) {
            //generate({qr: res.data.ebarimt.qrData})
            request({
              api: { method: "POST", url: "QR/Generate" },
              store: this.$store,
              data: { qr: res.data.ebarimt.qrData }
            }).then(res => {
              if (res != false) {
                this.ebarimtObj.base64 = res.data.base64;
              }
            });
            this.ebarimtObj.mode = 2;
            this.ebarimtObj.ebarimt = res.data.ebarimt;
            this.ebarimtObj.modal = true;
            this.ebarimtObj.key++;
          }
        }
      });
    },
    generateEbarimt() {
      let errs = [];
      if (!(this.ebarimtObj.type == "1" || this.ebarimtObj.type == "0")) {
        errs.push("И-баримт авах хэлбэр сонгоно уу!");
      }

      if (this.ebarimtObj.type == "1" && this.ebarimtObj.regNo.length == 0) {
        errs.push("Байгууллагын регистер бичнэ үү!");
      }

      if (errs.length > 0) {
        this.$Notice.warning({ title: "Мэдэгдэл", desc: errs[0] });
      } else {
        //$("#app").addClass("dynamic-locker");
        // postEBarimtOption({
        //   invoiceId: this.ebarimtObj.id,
        //   type: parseInt(this.ebarimtObj.type, 10),
        //   regNo: parseInt(this.ebarimtObj.regNo, 10)
        // })

        request({
          api: { method: "POST", url: "EBarimt/PostEBarimtOption" },
          store: this.$store,
          data: {
            invoiceId: this.ebarimtObj.id,
            type: parseInt(this.ebarimtObj.type, 10),
            regNo: parseInt(this.ebarimtObj.regNo, 10)
          }
        }).then(res => {
          //$("#app").removeClass("dynamic-locker");
          if (res != false) {
            // if (this.ebarimtObj.type == "1") {
            //   this.ebarimtObj.mode = 3;
            //   this.ebarimtObj.modal = true;
            //   this.ebarimtObj.key++;
            // } else {

              //$("#app").addClass("dynamic-locker");
              //createBill({ id: this.ebarimtObj.id })
              request({
                api: { method: "POST", url: "EBarimt/CreateBill" },
                store: this.$store,
                data: {
                  id: this.ebarimtObj.id
                }
              }).then(res => {
                //$("#app").removeClass("dynamic-locker");
                if (res != false) {
                  request({
                    api: { method: "POST", url: "QR/Generate" },
                    store: this.$store,
                    data: { qr: res.data.ebarimt.qrData }
                  }).then(res => {
                    if (res != false) {
                      this.ebarimtObj.base64 = res.data.base64;
                    }
                  });
                  this.ebarimtObj.mode = 2;
                  this.ebarimtObj.ebarimt = res.data.ebarimt;
                  this.ebarimtObj.modal = true;
                  this.ebarimtObj.key++;
                }
              });
            //}
          }
        });
      }
    },

    // eventDetail(id) {
    //   this.toggleBodyClass("addClass", "dynamic-locker");

    //   request({
    //     api: { method: "get", url: "task/taskInheritedDetail" },
    //     params: { id: id },
    //     store: this.$store
    //   }).then(res => {
    //     this.toggleBodyClass("removeClass", "dynamic-locker");
    //     if (res != false) {
    //       this.modal.id = id;
    //       this.modal.data = res.data.task;
    //       this.modal.show = true;
    //     }
    //   });
    //},
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },
    downloadEbarimt() {
      var _content = this.$refs.mdlEbarimt.innerHTML;
      var mywindow = window.open("", "Print", "height=600,width=400");

      mywindow.document.write("<html><head><title>Print</title>");
      mywindow.document.write("</head><body >");
      mywindow.document.write(_content);
      mywindow.document.write("</body></html>");

      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    }
  }
};
</script>
